// extracted by mini-css-extract-plugin
export default {"meetingDetails":"guestpage_meetingDetails__gN+Mr"};